// Attrition: the list its address can open. No React in here.
//
// The home screen's "N exits this month" opens the dashboard's own leaver list on that
// month. The two hold the same people: the server counts the number and lists the
// leavers from the same roster, narrowed by the same viewer scope and Role filter, and
// places each person in a month by the same exit date. A last working day still to come
// this month is in both. They can differ only in the ways every live-counted card can: a
// change in the minute the directory is remembered for, or a home screen left open
// across the end of a month.
//
// Page search does not name this list (DASHBOARD_LISTS.Attrition is empty). Someone typing
// "exit" would find it by its name but the Attrition dashboard only by its keywords, so
// the list would be offered above the dashboard itself.
import type { DashboardListInfo } from './types';

/** The slug the home screen links to: everyone who left in the month on screen. */
export const EXITS_SLUG = 'exits';

/** Every list on Attrition that can be opened by address. */
export const LISTS: DashboardListInfo[] = [
  {
    slug: EXITS_SLUG,
    // The pop-up's own title.
    name: 'Exited employees by tenure',
    // No promise of scores: those columns are shown only on a project with a scorecard.
    line: 'Everyone who left in the month, last working days still to come included, with tenure and last store.',
    keywords: 'exits leavers resigned left',
  },
];
